import { render } from "./RecentActivityCard.vue?vue&type=template&id=7c62964e&scoped=true&ts=true"
import script from "./RecentActivityCard.vue?vue&type=script&lang=ts"
export * from "./RecentActivityCard.vue?vue&type=script&lang=ts"

import "./RecentActivityCard.vue?vue&type=style&index=0&id=7c62964e&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c62964e"]])

export default __exports__